module.exports = __webpack_public_path__ + "img/zl_icon.a2b4b52.png";